import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
}
export function CTAButton({
  text = 'SÍ, QUIERO MI LIBERTAD OPERATIVA — ACCEDER AL KIT POR $27',
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://protocolzenith.com/73760899126/invoices/0dc8aa963c53b943ac8220908ef3b2c8" target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px 0px rgba(37, 211, 102, 0.4)', '0px 0px 20px 5px rgba(37, 211, 102, 0.4)', '0px 0px 0px 0px rgba(37, 211, 102, 0.4)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} className={`relative group w-full sm:w-auto inline-flex items-center justify-center px-6 py-4 sm:px-8 sm:py-5 text-base sm:text-lg font-bold text-black bg-whatsapp rounded-xl overflow-hidden transition-all no-underline ${className}`} data-id="element-17">
      <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-18" />
      <span className="relative flex items-center gap-2 text-center" data-id="element-19">
        {text}
        <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-20" />
      </span>
    </motion.a>;
}